// React
import React from "react";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./FieldString.less";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class FieldString extends React.Component {
    render() {
        let { label, labelWidth, value } = this.props;
        if (!labelWidth) {
            labelWidth = 100;
        }
        return (React.createElement("div", { className: styles.field },
            React.createElement("div", { style: { width: labelWidth }, className: styles.label },
                label,
                ":"),
            React.createElement("div", { className: styles.value }, value)));
    }
}
